import React from 'react'

const PalliativeCareArticles = () => {
  return (
    <>
    
    <p className='text-danger p-50 text-center'>No News Letters</p>
    <p className='h-100'></p>
  <p className='h-100'></p>
  <p className='h-100'></p>
  <p className='h-100'></p>
  <p className='h-100'></p>
  

    </>
  )
}

export default PalliativeCareArticles